import { makeStyles, shorthands } from "@fluentui/react-components";

export const useToastStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap("8px"),
    ...shorthands.padding("10px", "12px"),
  },

  error: {
    backgroundColor: "#FDF6F3",
    ...shorthands.borderBottom("1px", "solid", "#F4BFAB"),
    ...shorthands.borderTop("1px", "solid", "#F4BFAB"),
    color: "#DA3B01",
  },

  success: {
    backgroundColor: "#F1FAF1",
    ...shorthands.borderBottom("1px", "solid", "#9FD89F"),
    ...shorthands.borderTop("1px", "solid", "#9FD89F"),
    color: "#0E700E",
  },

  info: {
    color: "#000000",
    flexGrow: 1,
    display: "flex",
    ...shorthands.gap("8px"),
    alignItems: "center",
  },
});
